






























import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getUrlParam from '@/common/utils/getUrlParam';
import { SelectBGMState } from "@/common/interface";
import getActivityType from '@/common/utils/getActivityType';
@Component
export default class BGMIcon extends Vue {
  @Getter("bgmIcon") bgmIcon!: string;
  @Getter("selectedBGM") selectedBGM!: SelectBGMState;
  @Getter("distributeTabFixed") distributeTabFixed!:boolean;
  playBGM: boolean = false;
  getUrlParam: Function = getUrlParam;
  getActivityType: Function = getActivityType;


  @Watch("selectedBGM")
  changePlayBGM(val: SelectBGMState, oldVal: SelectBGMState) {
    if (val.url) {
      this.playBGM = true;
      const globalAudio = document.querySelector(".selected-bgm");
      document.addEventListener('touchstart',  this.handelPlayBgm, false)
    }
  }
  mounted() {
    const globalAudio = document.querySelector(".selected-bgm");
    if (this.selectedBGM.url && getUrlParam("type") !== "demo") {
      this.playBGM = true;
      if(globalAudio) {
       document.addEventListener('touchstart',  this.handelPlayBgm, false)
      }
    }
    window.wx.ready(() => {
      // const globalAudio = document.querySelector(".selected-bgm");
      window.WeixinJSBridge.on('onPageStateChange', function(res: any) {
        // 注意：res.active返回的是字符串类型的true和false
        if (globalAudio !== null) {
          if (res.active === 'true') {
            (globalAudio as HTMLAudioElement).play();
          } else {
            (globalAudio as HTMLAudioElement).pause();
          }
        }
      });
    });
  }
  handelPlayBgm() {
    if(this.playBGM) {
      console.log('play');
      const globalAudio = document.querySelector(".selected-bgm");
      (globalAudio as HTMLAudioElement).play()
      document.removeEventListener('touchstart', this.handelPlayBgm);
    }
  }
  handleSwitchMusic() {
    if (this.selectedBGM.url) {
      const globalAudio = document.querySelector(".selected-bgm");
      if (this.playBGM) {
        this.playBGM = false;
        (globalAudio as HTMLAudioElement).pause();
      } else {
        this.playBGM = true;
        (globalAudio as HTMLAudioElement).play();
      }
    }
  }

}
